import axios from "axios";

// SEO pages

export const getPageInfo = path => axios.get(`/api/v1/browse/page_info?path=${path}`);
export const getPageInfoByQuery = query => axios.get(`/api/v1/browse/page_info?${query}`);
